// Shopify Theme Main JS
console.log('Amori Theme Loaded');

// Global Cart Logic
window.refreshCartDrawer = async function() {
  try {
    // 1. Atualizar contadores de itens (se houver)
    const cartRes = await fetch('/cart.js').then(r => r.json());
    document.querySelectorAll('.header-cart-count, .cart-count').forEach(el => {
      el.textContent = cartRes.item_count;
      if (cartRes.item_count > 0) {
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });

    // 2. Buscar a seção do carrinho lateral atualizada
    const res = await fetch(window.location.pathname + '?sections=cart-drawer');
    const sections = await res.json();
    const html = sections['cart-drawer'];
    
    if (!html) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const itemsContainer = document.getElementById('cart-drawer-items');
    const footerContainer = document.getElementById('cart-drawer-footer');
    
    const newItems = doc.getElementById('cart-drawer-items');
    const newFooter = doc.getElementById('cart-drawer-footer');

    if (itemsContainer && newItems) itemsContainer.innerHTML = newItems.innerHTML;
    if (footerContainer && newFooter) footerContainer.innerHTML = newFooter.innerHTML;

    // Trigger cart:updated para outros ouvintes
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartRes }));
  } catch (e) {
    console.error('Error refreshing cart drawer:', e);
  }
};

window.updateCartQty = async function(line, qty) {
  if (qty < 0) return;
  
  // Limpar mensagens de erro anteriores
  document.querySelectorAll('.cart-item-error').forEach(el => {
    el.classList.add('hidden');
    el.textContent = '';
  });

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    });
    
    const data = await response.json();

    if (response.ok) {
      await window.refreshCartDrawer();
      
      // Se o Shopify retornar uma quantidade menor que a solicitada, avisar o usuário
      // Nota: o índice no array data.items é 0-based, enquanto 'line' é 1-based
      const item = data.items[line - 1];
      if (item && item.quantity < qty && qty !== 0) {
          showCartError(line, 'Estoque máximo atingido');
      }
    } else {
      console.error('Error updating cart:', data.description || 'Unknown error');
      let errorMessage = 'Produto sem estoque suficiente';
      if (data.description && data.description.includes('cannot add')) {
          errorMessage = 'Não é possível adicionar mais deste item';
      }
      showCartError(line, errorMessage);
    }
  } catch (e) { 
    console.error('Error updating qty:', e); 
    showCartError(line, 'Erro ao atualizar. Tente novamente.');
  }
};

window.removeCartItem = async function(line) {
  await window.updateCartQty(line, 0);
};

function showCartError(line, message) {
    const errorEl = document.querySelector(`.cart-item-error[data-line="${line}"]`);
    if (errorEl) {
        errorEl.textContent = message;
        errorEl.classList.remove('hidden');
    } else {
        alert(message);
    }
}

// Interceptar submissões de formulário "Add to Cart" para AJAX
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (form.action && form.action.includes('/cart/add')) {
    e.preventDefault();
    const formData = new FormData(form);
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        await window.refreshCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:open'));
      } else {
        const errorData = await response.json();
        alert(errorData.description || 'Erro ao adicionar ao carrinho.');
      }
    } catch (error) {
      console.error('AJAX Add Error:', error);
    }
  }
});
